/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// ── CATCH CREDIT DELIVERY FEE ──
// Automatically adds the correct zone/delivery fee(s) to the cart
// when a Catch Credit Member proceeds to checkout on the /cart page.

(function () {

  // Only run on the cart page
  if (window.location.pathname !== '/cart') return;

  // Zone fee variant IDs — always charged for these zones
  var CC_ZONE_FEES = {
    'Los Angeles': 51885277970564,  // $3.50
    'Camarillo':   51885277937796   // $3.50
  };

  // Home delivery fee variant IDs — only charged if pickup_site contains 'Home Delivery'
  var CC_HOME_DELIVERY_FEES = {
    'Los Angeles':       51885297336452,  // $10.00
    'Carpinteria':       51885278003332,  // $6.00
    'Goleta':            51885278036100,  // $7.00
    'Montecito':         51885278068868,  // $8.00
    'Ojai':              51885278101636,  // $9.00
    'Santa Barbara':     51885278134404,  // $6.00
    'Santa Ynez Valley': 51885278167172,  // $11.00
    'Ventura':           51885278199940   // $6.00
  };

  // Catch Credit signup variant IDs — if any are in cart, skip fee logic
  var CC_SIGNUP_VARIANTS = [51850991861892, 51850991894660, 51850994122884];

  // All Catch Credit fee variant IDs — used to detect if fee already in cart
  var ALL_FEE_VARIANTS = Object.values(CC_ZONE_FEES).concat(Object.values(CC_HOME_DELIVERY_FEES));

  // Check if customer is a Catch Credit Member via Liquid-injected meta tag
  var isCatchCreditMember = document.querySelector('meta[name="cc-member"]') !== null;
  if (!isCatchCreditMember) return;

// Zero balance gate — read from Liquid-injected meta tag, no API call needed
var ccBalanceEl = document.querySelector('meta[name="cc-balance"]');
var ccBalance   = ccBalanceEl ? parseFloat(ccBalanceEl.getAttribute('content')) : null;

if (ccBalance !== null && ccBalance <= 0) {
  var zeroBalanceBtn = document.querySelector('#main-cart [name="checkout"]');
  if (zeroBalanceBtn) {
    zeroBalanceBtn.addEventListener('click', function (e) {
      e.preventDefault();
      // Only inject once
      if (document.getElementById('cc-zero-balance-msg')) return;
      var msg = document.createElement('div');
      msg.id = 'cc-zero-balance-msg';
      msg.style.cssText = [
        'background:#e6f2f3',
        'border:1px solid #b5dfe2',
        'border-radius:12px',
        'padding:16px 20px',
        'margin-bottom:16px',
        'font-family:Raleway,sans-serif',
        'display:flex',
        'align-items:center',
        'justify-content:space-between',
        'flex-wrap:wrap',
        'gap:12px'
      ].join(';');
      msg.innerHTML = [
        '<div>',
          '<div style="font-size:14px;font-weight:700;color:#1f3a4a;margin-bottom:4px;">Your Catch Credit balance is $0</div>',
          '<div style="font-size:13px;color:#556881;">Top up your account to keep shopping the catch.</div>',
        '</div>',
        '<a href="/account" style="',
          'display:inline-block;',
          'background:#0d616a;',
          'color:#ffffff;',
          'font-family:Raleway,sans-serif;',
          'font-size:13px;',
          'font-weight:700;',
          'padding:10px 20px;',
          'border-radius:8px;',
          'text-decoration:none;',
          'white-space:nowrap;',
          'flex-shrink:0',
        '">Top up &rarr;</a>'
      ].join('');
      zeroBalanceBtn.closest('form') 
        ? zeroBalanceBtn.closest('form').insertAdjacentElement('beforebegin', msg)
        : zeroBalanceBtn.insertAdjacentElement('beforebegin', msg);
      msg.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
  return;
}

  // Get pickup location and site from Liquid-injected meta tags
  var pickupLocationEl = document.querySelector('meta[name="cc-pickup-location"]');
  var pickupSiteEl     = document.querySelector('meta[name="cc-pickup-site"]');

  var pickupLocation = pickupLocationEl ? pickupLocationEl.getAttribute('content') : '';
  var pickupSite     = pickupSiteEl     ? pickupSiteEl.getAttribute('content')     : '';

  console.log('GH CC: pickup_location =', pickupLocation, '| pickup_site =', pickupSite);

  if (!pickupLocation) return;

  var isHomeDelivery = pickupSite && pickupSite.toLowerCase().indexOf('home delivery') !== -1;

  // Build list of fee variant IDs to add
  var feesToAdd = [];

  // Zone fee (LA and Camarillo only)
  if (CC_ZONE_FEES[pickupLocation]) {
    feesToAdd.push(CC_ZONE_FEES[pickupLocation]);
  }

  // Home delivery fee (any zone with home delivery)
  if (isHomeDelivery && CC_HOME_DELIVERY_FEES[pickupLocation]) {
    feesToAdd.push(CC_HOME_DELIVERY_FEES[pickupLocation]);
  }

  // No fees to add — exit
  if (feesToAdd.length === 0) return;

  // Find checkout form and button
  var cartSection = document.getElementById('main-cart');
  if (!cartSection) return;

  var checkoutBtn = cartSection.querySelector('[name="checkout"]');
  if (!checkoutBtn) return;

  checkoutBtn.addEventListener('click', function (e) {
    e.preventDefault();
    checkoutBtn.disabled = true;
    checkoutBtn.textContent = 'Checking delivery fee…';

    // Get current cart
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {

        // Skip if cart contains a Catch Credit signup product
        var hasSignup = cart.items.some(function (item) {
          return CC_SIGNUP_VARIANTS.indexOf(item.variant_id) !== -1;
        });
        if (hasSignup) { submitForm(); return; }

        // Filter out fees already in cart
        var variantIdsInCart = cart.items.map(function (item) { return item.variant_id; });
        var feesToAddNow = feesToAdd.filter(function (id) {
          return variantIdsInCart.indexOf(id) === -1;
        });

        if (feesToAddNow.length === 0) { submitForm(); return; }

        // Add all required fee variants
        var items = feesToAddNow.map(function (id) {
          return { id: id, quantity: 1 };
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function () {
          console.log('GH CC: delivery fees added', feesToAddNow);
          submitForm();
        })
        .catch(function (err) {
          console.error('GH CC fee add error:', err);
          submitForm(); // proceed anyway
        });

      })
      .catch(function (err) {
        console.error('GH CC cart fetch error:', err);
        submitForm(); // proceed anyway
      });

    function submitForm() {
      checkoutBtn.disabled = false;
      checkoutBtn.textContent = 'Check out';
      window.location.href = '/checkout';
    }
  });

})();

// ── HIDE CYMS FROM CATCH CREDIT MEMBERS ON MEMBER SHOP ──
(function() {
  if (window.location.pathname !== '/pages/member-shop') return;
  if (!document.querySelector('meta[name="cc-member"]')) return;
  var style = document.createElement('style');
  style.textContent = '[id$="section_collection_YBa4M3"] { display: none !important; }';
  document.head.appendChild(style);
})();